const isHttpsUrl = (url: string): boolean => {
  try {
    return new URL(url).protocol === "https:";
  } catch {
    return false;
  }
};

/** Opens an https url in a new tab; anything else is ignored. */
export const openInNewTab = (url: string) => {
  if (!isHttpsUrl(url)) return;
  const newWindow = window.open(url, "_blank", "noopener,noreferrer");
  if (newWindow) newWindow.opener = null;
};
